/**
 * <submit-button>
 * -----------------------------------------------------------------------------
 *
 * @type {Component}
 *
 * -----------------------------------------------------------------------------
 */

parasails.registerComponent('submit-button', {

  //  ╔═╗╦ ╦╔╗ ╦  ╦╔═╗  ╔═╗╦═╗╔═╗╔═╗╔═╗
  //  ╠═╝║ ║╠╩╗║  ║║    ╠═╝╠╦╝║ ║╠═╝╚═╗
  //  ╩  ╚═╝╚═╝╩═╝╩╚═╝  ╩  ╩╚═╚═╝╩  ╚═╝
  props: [
    'event_id',
    'device_id',
    'selectedindex'
  ],

  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╦╔╗╔╔╦╗╔═╗╦═╗╔╗╔╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ║║║║ ║ ║╣ ╠╦╝║║║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╩╝╚╝ ╩ ╚═╝╩╚═╝╚╝╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: function () {
    return {
      // buttonimage: '../images/Submit_withTXT.webp',
      // buttonimageON: '../images/Submit_withTXT_on.webp',
      // buttonimageOFF: '../images/Submit_withTXT.webp',
      buttonimage: '../images/enjoy/button_submit.webp',
      buttonimageON: '../images/enjoy/button_submit_on.webp',
      buttonimageOFF: '../images/enjoy/button_submit.webp',
      hasVoted: false
    };
  },


  //  ╦ ╦╔╦╗╔╦╗╦
  //  ╠═╣ ║ ║║║║
  //  ╩ ╩ ╩ ╩ ╩╩═╝

  template: `
      <img v-bind:src="buttonimage" v-on:click="submitClicked" v-on:mousedown="press" v-on:touchstart="press" v-on:mouseup="release" v-on:touchend="release" :disabled="enableButton" />
      `,


  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  mounted: async function() {
    this.buttonimage = this.buttonimageOFF;
  },

  beforeDestroy: function() {

  },

  computed: {
    buttonID: function () { return 'id' + this.voteindex; },
    altText: function () { return '選択肢' + this.voteindex; },
    enableButton: function () {return this.$parent.selectedVoteIndex !== -1;}
  },

  watch: {
    enableButton: {
      handler: function(newVal, oldValue) {
        if(this.enableButton === true) {
          this.buttonimage = this.buttonimageON;
        } else {
          this.buttonimage = this.buttonimageOFF;
        }
      }
    }
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {

    //  ╦╔╗╔╔╦╗╔═╗╦═╗╔╗╔╔═╗╦    ╔═╗╦  ╦╔═╗╔╗╔╔╦╗  ╦ ╦╔═╗╔╗╔╔╦╗╦  ╔═╗╦═╗╔═╗
    //  ║║║║ ║ ║╣ ╠╦╝║║║╠═╣║    ║╣ ╚╗╔╝║╣ ║║║ ║   ╠═╣╠═╣║║║ ║║║  ║╣ ╠╦╝╚═╗
    //  ╩╝╚╝ ╩ ╚═╝╩╚═╝╚╝╩ ╩╩═╝  ╚═╝ ╚╝ ╚═╝╝╚╝ ╩   ╩ ╩╩ ╩╝╚╝═╩╝╩═╝╚═╝╩╚═╚═╝

    submitClicked: function () {
      // `this` inside methods points to the Vue instance
      if(this.enableButton === false) return;
      this.hasVoted = this.$parent.currentVoteData.voted;
      //if(this.hasVoted === false) {
        this.buttonimage = this.buttonimageON;
        io.socket.post('/vote', { eventid: this.event_id, partindex: this.$parent.partIndex, questionindex: this.$parent.questionIndex,  voteIndex: this.$parent.currentVoteData.votedIndex, deviceID: this.device_id });
        this.$emit('voted');
      //}
    },

    enableChanged: function() {
      if(this.enableButton === true) {
        this.buttonimage = this.buttonimageON;
      } else {
        this.buttonimage = this.buttonimageOFF;
      }
    },

    press: function() {
      this.hasVoted = this.$parent.currentVoteData.voted;
      // if(this.hasVoted === false) {
      //   this.buttonimage = this.buttonimageON;
      // } else {
      //   this.buttonimage = this.buttonimageOFF;
      // }
    },
    release: function(){
    }
    //…

    //  ╔═╗╦ ╦╔╗ ╦  ╦╔═╗  ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
    //  ╠═╝║ ║╠╩╗║  ║║    ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
    //  ╩  ╚═╝╚═╝╩═╝╩╚═╝  ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝
    // > Public methods are rarely exposed by Vue components, but sometimes they
    // > are an important escape hatch.  They are callable via something like
    // > `this.$refs.componentNameInCamelCase.doSomething())`, and, by convention,
    // > are always prefixed with "do".
    // N/A

    //  ╔═╗╦═╗╦╦  ╦╔═╗╔╦╗╔═╗  ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
    //  ╠═╝╠╦╝║╚╗╔╝╠═╣ ║ ║╣   ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
    //  ╩  ╩╚═╩ ╚╝ ╩ ╩ ╩ ╚═╝  ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

    //…

  }
  /* <div class="like-button">
          <img src={{buttonOFF[voteIndex - 1]}} v-on:click="voteClicked" />
        </div> */

});



